import React, { FC } from 'react';
import styled from 'styled-components';

import { UserPolicyLink } from '~/atomic/atom/links/staticLinks';
import { PaperStyle } from '~/atomic/atom/PaperStyle';
import { CheckForm } from '~/atomic/page/anti-pirate/check/CheckForm';
import { CheckResult } from '~/atomic/page/anti-pirate/check/CheckResult';
import { SCPageTitle, TextRegStyle } from '~/atomic/Typography';
import { lessThan } from '~/lib/mediaQuery';

export const Check: FC = () => {
  return (
    <SCCheck>
      <SCContent>
        <SCPageTitleRow>
          <SCPageTitle>
            Поиск нарушителей авторских прав
          </SCPageTitle>
        </SCPageTitleRow>
        <SCInfoBlock>
          <SCInfoBlockMessage>
            Копирование и распространение произведений, размещенных на площадке Букривер,
            является нарушением правил
            {' '}
            <UserPolicyLink>
              <a
                target="_blank"
                rel="noopener noreferrer"
              >
                Пользовательское соглашение
              </a>
            </UserPolicyLink>
            {' '}
            и прав правообладателей.
            Действие аккаунта пользователя и оплаченные им ранее доступы к произведениям
            прекращаюся без возврата средств.
          </SCInfoBlockMessage>
        </SCInfoBlock>
        <SCPageContentRow>
          <SCPageContent>
            <SCDescription>
              Загрузите файл для идентификации
              читателя, которому принадлежит данная копия. Укажите ссылку на произведение
              на площадке.
            </SCDescription>
            <CheckForm />
          </SCPageContent>
        </SCPageContentRow>
      </SCContent>
      <CheckResult />
    </SCCheck>
  );
};

const SCDescription = styled.div`
  ${TextRegStyle};
  margin-bottom: 34px;

  color: var(--black-color);
`;

const SCInfoBlockMessage = styled.div`
  ${TextRegStyle};
  
  color: var(--black-color);
`;

const SCInfoBlock = styled.div`
  width: 100%;
  padding: 20px 16px;
  background-color: #fef4f6;
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
`;

const SCPageContent = styled.div`
  ${PaperStyle};
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 16px;
  padding-bottom: 36px;
  width: 100%;
`;

const SCPageContentRow = styled.div`
  display: flex;
  flex-direction: row;
`;

const SCPageTitleRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 20px;
`;

const SCContent = styled.div`
  padding-top: 34px;
  padding-bottom: 60px;
  max-width: 769px;
  width: 100%;
  margin-right: 16px;

  ${lessThan('md')} {
    max-width: 100%;
    padding-left: 16px;
    padding-right: 16px;
    margin-right: unset;
    padding-bottom: unset;
  }
`;

const SCCheck = styled.div`
  display: flex;
  flex-direction: row;
  min-height: 100%;
  
  ${lessThan('md')} {
    flex-direction: column;
    align-items: center;
  }
`;
